import { BiCategoryAlt } from 'react-icons/bi';
import { BsThreads } from 'react-icons/bs';
import { FaUsers } from 'react-icons/fa';
import { IoNotifications, IoSendSharp } from 'react-icons/io5';
import { LuCalendarDays } from 'react-icons/lu';
import { MdGroups } from 'react-icons/md';
import { FaBlogger } from "react-icons/fa";
import { FaRegNewspaper } from "react-icons/fa";
import { BiCommentDetail } from "react-icons/bi";
import { MdOutlineEventNote } from "react-icons/md";
import { MdOutlineRateReview } from "react-icons/md";
export const navLinks = [
	{
		to: '/blog',
		text: 'Blog',
		Icon: FaBlogger,
	},
		{
		to: '/events',
		text: 'Events',
		Icon: MdOutlineEventNote ,
	},
		{
		to: '/newsLetter',
		text: 'NewsLetter',
		Icon: FaRegNewspaper ,
	},
	{
		to: '/comments',
		text: 'Comments',
		Icon: BiCommentDetail ,
	},
	{
		to: '/testimonial',
		text: 'Testimonial',
		Icon: MdOutlineRateReview ,
	},
	{
		to: '/users',
		text: 'Users',
		Icon: FaUsers,
	},
	{
		to: '/userevents',
		text: 'User Events',
		Icon: LuCalendarDays,
	},
	{
		to: '/category',
		text: 'Categories',
		Icon: BiCategoryAlt,
	},
	{
		to: '/threads',
		text: 'Threads',
		Icon: BsThreads,
	},
	{
		to: '/groups',
		text: 'Groups',
		Icon: MdGroups,
	},
	{
		to: '/notifications',
		text: 'Notifications',
		Icon: IoNotifications,
	},
	{
		to: '/send-notification',
		text: 'Global Notifications',
		Icon: IoSendSharp,
	},
];
